<template>
  <div class="box" style="height: 100%">
    <div class="backButton" @click="goback"><i class="el-icon-back"></i></div>
    <div class="orderTitle">公告中心</div>
    <div class="notice">
      <div class="notContent">
        <p
          class="noticeitem"
          v-for="(noticeItem, index) in noticeList"
          :key="index"
          style="display: flex; justify-content: space-between; cursor: pointer"
          @click="goDetail(noticeItem.id)"
        >
          <span class="word">{{ index + 1 }}. {{ noticeItem.title }}</span>
          <span class="time">{{ noticeItem.time }}</span>
        </p>
        <div class="pageWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>

      <!-- <div class="more">
          查看更多
        </div> -->
    </div>
    <descDialog ref="descDialog" />
  </div>
</template>
<script>
/*global http protocol util */

import descDialog from './detailDialog.vue'
export default {
  name: 'NoticeCC',
  components: {
    descDialog
  },
  data() {
    return {
      pageData: {
        total: null,
        pageSizes: [10, 20],
        pageSize: 10,
        currentPage: 1
      },
      items: [],
      oneItmes: {},
      content: '',
      isNotice: true,
      abstract: [],
      klineTimeout: null,
      noticeList: [],
      CommodityTqTip: [],
      ConcludeStage: []
    }
  },

  mounted() {
    this.getArticle()
  },
  beforeDestroy() {
    protocol.param_noticeList.param.articleTitle = ''
    clearTimeout(this.klineTimeout)
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    goDetail(id) {
      this.$refs.descDialog.showDialog(id)
    },
    getArticle() {
      this.noticeList = []
      // protocol.param_noticeList.param.columnId = window.c.notice // 2020.5.6 新增 8/18修改
      protocol.param_noticeListByColumnId.param.page = this.pageData.currentPage - 1
      protocol.param_noticeListByColumnId.param.size = this.pageData.pageSize
      protocol.param_noticeListByColumnId.param.columnId = 346
      http.getRes(protocol.param_noticeListByColumnId).then((response) => {
        const { content, totalElements } = response.data.value
        this.pageData.total = Number(totalElements)
        if (content) {
          for (const value of content) {
            const obj = value
            obj.time = util.dateDayFormate(Number(value.updateTime))
            this.noticeList.push(obj)
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getArticle()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getArticle()
    },
    goNotice() {
      window.sessionStorage.setItem('selectnPage', 2)
      this.$router.push('/notice')
    },
    goWhitePage() {
      window.sessionStorage.setItem('selectnPage', 1)
      this.$router.push('/notice')
    },
    // 商品现货买进费用策略查询
    param_queryCommodityTqTip() {
      // item
      const _this = this
      if (this.item == '--') {
        setTimeout(() => {
          _this.param_queryCommodityTqTip()
        }, 1000)
        return
      }
      protocol.param_queryCommodityTqTip.param.commodityId = this.item
      http.postFront(protocol.param_queryCommodityTqTip).then((response) => {
        const { code, message, value } = response.data
        if (code == 0) {
          this.CommodityTqTip = value
        } else {
          this.$message(message)
        }
      })
    },
    // 查询订立参数
    param_findConcludeStage() {
      // item
      const _this = this
      if (this.item == '--') {
        setTimeout(() => {
          _this.param_findConcludeStage()
        }, 1000)
        return
      }
      protocol.param_findConcludeStage.param.commodityId = this.item
      http.postFront(protocol.param_findConcludeStage).then((response) => {
        const { code, message, value } = response.data
        if (code == 0) {
          this.ConcludeStage = value
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.box {
  width: 1200px;
  height: 100%;
  margin: 34px auto;

  .backButton {
    cursor: pointer;
    position: fixed;
    left: 50px;
    top: 70px;
    width: 40px;
    height: 40px;
    background: #000000;
    border-radius: 2px 2px 2px 2px;
    opacity: 0.5;

    color: #fff;
    font-size: 20px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .orderTitle {
    font-family: PingFang TC, PingFang TC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
  }
  .notice {
    margin-top: 10px;
    // height: 800px;
    .word {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    .time {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
  .notContent {
    // height: calc(100% - 50px);
    min-height: 392px;
    overflow-y: auto;
    // padding: 20px;
    .noticeitem {
      height: 52px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
    }
  }
  .pageWrap {
    margin-top: 10px;
    width: 100%;
    text-align: center;
  }
}
</style>
